"use strict";
exports.__esModule = true;
var FormFieldType;
(function (FormFieldType) {
    FormFieldType["DROPDOWN"] = "DROPDOWN";
    FormFieldType["NUMBER"] = "NUMBER";
    FormFieldType["DATE"] = "DATE";
    FormFieldType["DATE_TEXT"] = "DATE_TEXT";
    FormFieldType["TEXT_BOX"] = "TEXT_BOX";
    FormFieldType["OTP"] = "OTP";
    FormFieldType["CHECKBOX"] = "CHECKBOX";
    FormFieldType["PLAN_SELECTION"] = "PLAN_SELECTION";
    FormFieldType["PHONE_NUMBER"] = "PHONE_NUMBER";
    FormFieldType["EMAIL"] = "EMAIL";
    FormFieldType["TNC_CHECKBOX"] = "TNC_CHECKBOX";
    FormFieldType["RADIO_OPTIONS"] = "RADIO_OPTIONS";
    FormFieldType["DATE_DROPDOWN"] = "DATE_DROPDOWN";
    FormFieldType["SELECT_DROPDOWN"] = "SELECT_DROPDOWN";
    FormFieldType["QUESTION"] = "QUESTION";
    FormFieldType["ADDRESSES"] = "ADDRESSES";
    FormFieldType["SWITCH_BUTTON"] = "SWITCH_BUTTON";
    FormFieldType["CURRENCY"] = "CURRENCY";
    FormFieldType["PINCODE"] = "PINCODE";
    FormFieldType["RESIDENTIAL_ADDRESS"] = "RESIDENTIAL_ADDRESS";
    FormFieldType["WORK_ADDRESS"] = "WORK_ADDRESS";
    FormFieldType["CARD_DELIVERY_ADDRESS"] = "CARD_DELIVERY_ADDRESS";
    FormFieldType["DATE_PICKER"] = "DATE_PICKER";
    FormFieldType["RADIO"] = "RADIO";
    FormFieldType["PIN_CODE"] = "PIN_CODE";
    FormFieldType["FORM_ACTION_CARD"] = "FORM_ACTION_CARD";
    FormFieldType["TEXT_SEARCH"] = "TEXT_SEARCH";
    FormFieldType["DROPDOWN_BOTTOM_SHEET"] = "DROPDOWN_BOTTOM_SHEET";
    FormFieldType["TENURE"] = "TENURE";
})(FormFieldType = exports.FormFieldType || (exports.FormFieldType = {}));
